import actions from "./actions";

const {FETCH_RESULTS, FETCH_RESULTS_RESET} = actions;
const initState = {
    results: {},
};

const StudentResultsReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_RESULTS:
            return {
                ...state,
                results: data
            }
        case FETCH_RESULTS_RESET:
            return {
                ...state,
                results: {},
            };
        default:
            return state;
    }
}

export default StudentResultsReducer;
